/**
 * Header info block
 */
function info(msg) {
    var iw = $('.info-window');
    if (!iw.is(':visible')) {
        iw.find('p').html(msg);
        iw.slideDown();
        setTimeout(function() {
            iw.slideUp();
        }, 3500);
    }
}


/**
 * Header info block with delay option
 * delay == 'forever' - info block will not hide
 */
function infoWithDelay(msg, delay) {
    var iw = $('.info-window');
    if (!iw.is(':visible')) {
        if (delay) {
            if (delay == "forever") {
                iw.find('p').html("<svg class='close_head_message_svg' onclick='infoClose()'><use xlink:href='#icon-close-thin'/></svg>" + msg);
                iw.slideDown();
                return false;
            }
        }
        else {
            var delay = 3500;
        }
        iw.find('p').html(msg);
        iw.slideDown();
        setTimeout(function() {
            iw.slideUp();
        }, delay);
    }
}

/**
 * Close info header message
 */
function infoClose() {
    $('.info-window').slideUp();
}

/**
 * DOCUMENT READY SCRIPT
 */
$(function() {
    /**
     * Tabbed navs activate
     */
    $('.tab-nav a.active').click();

    /**
     * Enable password revealing
     */
    if ($.fn.hideShowPassword) {
        $('[type=password]').hideShowPassword(false, true);
    }

    /**
     * Caps-lock warning
     */
    if ($.fn.capslockstate) {
        $(window).capslockstate();
    }
    function cl_warning_on() {
        var warn = $('[type=password]').closest('.form-field').find('.error.caps');
        if (!warn.length) {
            $('<label class="error caps">CAPS LOCK ON</label>').appendTo($('[type=password]').closest('.form-field'));
        }
    }
    function cl_warning_off() {
        $('.error.caps').remove();
    }
    $(window).bind('capsOn', function(event) {
        cl_warning_on();
    });
    $(window).bind('capsOff capsUnknown', function(event) {
        cl_warning_off();
    });
    $('[type=password]').bind('focusout', function(event) {
    });
    $('[type=password]').bind('focusin', function(event) {
        if ($(window).capslockstate('state') === true) {
            cl_warning_on();
        }
    });


    /**
     * Anti-bot
     */
    $('[name=sender]').val(7);

    /**
     * Success info windows
     */
    if (typeof show_info_onload != 'undefined') {
        info(show_info_onload);
    }
    if (typeof show_info_delay_onload != 'undefined' && typeof show_info_delay_onload_delay != 'undefined') {
        infoWithDelay(show_info_delay_onload, show_info_delay_onload_delay);
    }

    /**
     * Capsulate landing on paste
     */
    var landing_capsulate = $('#landing-capsulate-form');
    if (landing_capsulate.length) {
        landing_capsulate.on('paste', '[name=url]', function() {
            // A small timeout after the pasting for actual change of value to kick in, yo
            setTimeout(
                function() {
                    landing_capsulate.submit();
                },
                100
            );
        });
    }

    /**
     * Auto open signup/in in landing
     */
    var hash = window.location.hash.substr(1);
    if (hash == 'signin') {
        $('a.sign-in').trigger('click');
    }
    if (hash == 'signup') {
        $('a.sign-up').trigger('click');
    }

    /** Only one time submit form*/
    $('body').on('submit', 'form', function () {
        $(this).find('button.js-one-submit-button').attr('disabled', true);
    });

    /**
     *
     */
    $('.js-toggle-block').on('click', function (e) {
        e.preventDefault();
        var href = $(this).attr('href');
        if (href.length > 0) {
            $(href).toggleClass('visible');
            if ($(href).hasClass('visible')) {
                $(href).children('input').focus();
            }
        }
    });
});
